import * as yup from 'yup';

const REQUIRED_LIMIT_SCHEMA = yup
  .number()
  .transform((value: number, originalValue: unknown) => {
    if (originalValue === '' || originalValue === null || originalValue === undefined) {
      return undefined;
    }

    return value;
  })
  .required('필수 입력 항목입니다.');

const NULLABLE_LIMIT_SCHEMA = yup
  .number()
  .transform((value: number, originalValue: unknown) => {
    if (originalValue === '' || originalValue === null) {
      return null;
    }

    return value;
  })
  .nullable()
  .default(null);

export const serviceOperationSettingsSchema = yup.object({
  feedbackManageYn: yup.string().oneOf(['Y', 'N']).required(),
  dictionaryLimit: REQUIRED_LIMIT_SCHEMA,
  pageLimit: REQUIRED_LIMIT_SCHEMA,
  companyChatTurnLimitMonthly: NULLABLE_LIMIT_SCHEMA,
  companyChatTurnLimitDaily: NULLABLE_LIMIT_SCHEMA,
  userChatTurnLimitDaily: NULLABLE_LIMIT_SCHEMA,
  supportedLanguages: yup
    .array()
    .of(yup.string().required())
    .min(1, 'M-GPT 지원 언어를 1개 이상 선택해주세요.')
    .required('M-GPT 지원 언어를 선택해주세요.'),
  memo: yup
    .string()
    .trim()
    .transform((value: string | null) => (value === '' ? null : value))
    .max(256, '메모는 최대 256자까지 입력 가능합니다.')
    .nullable()
    .default(null),
  accountLimit: REQUIRED_LIMIT_SCHEMA,
});

export type ServiceOperationSettingsFormValues = yup.InferType<typeof serviceOperationSettingsSchema>;

export const serviceOperationSettingsDefaultValues: ServiceOperationSettingsFormValues = {
  feedbackManageYn: 'Y',
  dictionaryLimit: 0,
  pageLimit: 0,
  companyChatTurnLimitMonthly: null,
  companyChatTurnLimitDaily: null,
  userChatTurnLimitDaily: null,
  supportedLanguages: [],
  memo: '',
  accountLimit: 0,
};
